import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layouts/BannerContact/BannerContactSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layouts/ContacSection/ContactSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layouts/Footer/Footer.tsx");
